export function formatDisplayName(
    displayName?: string | null,
    fallback?: string | null,
    detailsInNewRow = false
): string {
    const raw = displayName ?? "";
    const cleaned = raw.replace(/^\s*\[[^\]]+\]\s*/, "").trim();

    if (cleaned.length > 0) {
        if (detailsInNewRow) {
            // Move parenthetical details to a new line (e.g. "Name (Details)" => "Name\nDetails")
            return cleaned.replace(/\s*\(([^)]+)\)/g, (_, details) => `\n${details}`);
        }
        return cleaned;
    }

    if (raw.length > 0) {
        return raw;
    }

    return fallback ?? "";
}

